module.exports = __webpack_public_path__ + "static/media/04.1ce4f18e.png";